<template>
	<div class="formulate-simple-select">
		<v-select
			ref="select"
			:class="`formulate-input-element formulate-input-element--${context.type}`"
			:data-type="context.type"
			:modelValue="context._value"
			@update:modelValue="handleInput"
			:options="context.options"
			:reduce="(x) => x.value"
			v-bind="context.attrs"
			label="label"
			:appendToBody="true"
			:calculatePosition="calculateSelectPostion"
			:deselectFromDropdown="true"
		>
			<template #selected-option-container="{multiple, option}">
				<span v-if="multiple" class="noRender"></span>
				<span :class="`formulate-input-element--${context.type}__selected`" v-else>{{ option.label }}</span>
			</template>

			<template #option="{label}">
				<div class="formulate-option-selector__option">
					<span class="option-label">{{ label }}</span>
					<span class="icon icon--check--filled--inverted icon--shakespeare option-check"></span>
				</div>
			</template>

			<template #footer>
				<div v-for="option in context.options" :key="option.value" :class="`formulate-input-element--${context.type}__ph`">
					{{ option.label }}<span class="icon icon--check--filled--inverted icon--shakespeare option-check"></span>
				</div>
			</template>
		</v-select>
	</div>
</template>


<script src="./FormulateSimpleSelect.js"></script>
